/* STARKA Plus3 Landingpage – gemeinsames Script für alle plus3-Abschnitte.
   Wird von jedem Abschnitt eingebunden; läuft aber nur einmal (Guard unten). */
(function () {
  if (window.P3_LOADED) return;
  window.P3_LOADED = true;

  var cdTimer = null;

  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- Countdown: Aktionsende kommt aus dem Hero-Abschnitt (data-p3-deadline) ---------- */
  function initCountdown() {
    if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }
    var src = document.querySelector('[data-p3-deadline]');
    var raw = src ? src.getAttribute('data-p3-deadline') : '';
    var deadline = raw ? new Date(raw).getTime() : NaN;
    var boxes = document.querySelectorAll('[data-p3-cd-box]');
    var copies = document.querySelectorAll('[data-p3-cd-copy]');

    function hide() {
      boxes.forEach(function (el) { el.style.display = 'none'; });
      copies.forEach(function (el) { el.style.display = 'none'; });
    }
    function show() {
      boxes.forEach(function (el) { el.style.display = ''; });
      copies.forEach(function (el) { el.style.display = ''; });
    }
    if (isNaN(deadline)) { hide(); return; }

    var d = new Date(deadline);
    var dateStr = pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear();
    document.querySelectorAll('[data-p3-cd-date]').forEach(function (el) { el.textContent = dateStr; });

    function setAll(key, val) {
      document.querySelectorAll('[data-p3-cd="' + key + '"]').forEach(function (el) { el.textContent = val; });
    }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) { hide(); clearInterval(cdTimer); cdTimer = null; return; }
      setAll('d', pad(Math.floor(diff / 86400000)));
      setAll('h', pad(Math.floor((diff % 86400000) / 3600000)));
      setAll('m', pad(Math.floor((diff % 3600000) / 60000)));
      setAll('s', pad(Math.floor((diff % 60000) / 1000)));
    }
    show();
    tick();
    cdTimer = setInterval(tick, 1000);
  }

  /* ---------- Bild-Fallback ---------- */
  function initImages(scope) {
    scope.querySelectorAll('img[data-p3-fallback]:not([data-p3-bound])').forEach(function (img) {
      img.setAttribute('data-p3-bound', '1');
      img.addEventListener('error', function () {
        var fb = img.getAttribute('data-p3-fallback');
        if (fb && img.src !== fb) { img.src = fb; }
      }, { once: true });
    });
    scope.querySelectorAll('.p3-tile img:not([data-p3-bound])').forEach(function (img) {
      img.setAttribute('data-p3-bound', '1');
      img.addEventListener('error', function () {
        var t = img.closest('.p3-tile'); if (t) t.style.display = 'none';
      }, { once: true });
    });
  }

  /* ---------- Akkordeons (Kaufberatung / Technische Daten) ---------- */
  function initAccordions(scope) {
    scope.querySelectorAll('.p3-acc-head:not([data-p3-bound])').forEach(function (head) {
      head.setAttribute('data-p3-bound', '1');
      var btn = head.querySelector('.p3-acc-btn');
      if (!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      head.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(scope) {
    scope.querySelectorAll('.p3-faq-q:not([data-p3-bound])').forEach(function (btn) {
      btn.setAttribute('data-p3-bound', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('.p3-faq-item');
        var list = btn.closest('.p3-faq');
        var wasOpen = item.classList.contains('is-open');
        (list || document).querySelectorAll('.p3-faq-item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          var q = el.querySelector('.p3-faq-q'); if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------- Formular ----------
     Das Absenden übernimmt Shopify ({% form 'contact' %}). Nach dem Absenden:
     - ist eine Danke-Seite eingestellt, leitet der Abschnitt selbst sofort weiter (Inline-Script im Abschnitt);
     - sonst wird hier die Bestätigung eingeblendet. */
  function initForm(scope) {
    scope.querySelectorAll('.p3-form:not([data-p3-bound])').forEach(function (form) {
      form.setAttribute('data-p3-bound', '1');
      var confirmBox = form.querySelector('.p3-form-confirm');
      if (form.getAttribute('data-p3-posted') === 'true' && confirmBox) {
        confirmBox.classList.add('is-visible');
        confirmBox.scrollIntoView({ block: 'center' });
      }
    });
  }

  function initAll(scope) {
    scope = scope || document;
    initImages(scope);
    initAccordions(scope);
    initFaq(scope);
    initForm(scope);
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme-Editor: Abschnitt wurde neu gerendert */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
